import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingTable() {
  const [selected, setSelected] = useState<'pro' | 'acelerador'>('acelerador');
  return <section id="pricing" className="py-16 px-4 pt-[25px] pb-[25px]" data-id="element-216">
      <div className="max-w-lg mx-auto" data-id="element-217">
        <div className="text-center mb-8" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-black mb-1" data-id="element-219">
            ELEGÍ TU <span className="text-brand" data-id="element-220">ULTRAPACK</span>
          </h2>
        </div>

        <div className="flex flex-col gap-5" data-id="element-221">
          {/* Plan 1 — ULTRAPACK PRO */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('pro')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'pro' ? 'border-2 border-brand shadow-[0_0_30px_rgba(244,63,122,0.15)]' : 'border border-dark-border'}`} data-id="element-222">
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-223">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand' : 'border-gray-600'}`} data-id="element-224">
                {selected === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-225" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-226">
              <div className="flex items-start justify-between gap-3" data-id="element-227">
                <div data-id="element-228">
                  <div className="mb-1 text-[18px]" data-id="element-229">📘</div>
                  <h3 className="font-bold text-[14px]" data-id="element-230">
                    ULTRAPACK MANICURISTA PRO
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-231">
                    6 Tomos + 6 Bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-232">
                  <div className="text-gray-500 line-through text-xs" data-id="element-233">
                    $51.000
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-234">
                    $19.990{' '}
                    <span className="text-sm text-gray-500 font-medium" data-id="element-235">
                      ARS
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-236">
                Ideal para quien quiere construir un negocio serio
              </p>
            </div>
          </motion.button>

          {/* Plan 2 — ULTRAPACK + ACELERADOR */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelected('acelerador')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'acelerador' ? 'border-2 border-brand shadow-[0_0_30px_rgba(244,63,122,0.15)]' : 'border border-dark-border'}`} data-id="element-237">
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-238">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'acelerador' ? 'border-brand' : 'border-gray-600'}`} data-id="element-239">
                {selected === 'acelerador' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-240" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-241">
              <div className="flex items-start justify-between gap-3" data-id="element-242">
                <div data-id="element-243">
                  <div className="text-xl mb-1" data-id="element-244">🏆</div>
                  <h3 className="font-bold text-[14px]" data-id="element-245">
                    ULTRAPACK PRO + ACELERADOR ⭐
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-246">
                    6 Tomos + 6 Bonos + Ruta Crítica 30 Días
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-247">
                  <div className="text-gray-500 line-through text-xs" data-id="element-248">
                    $69.000
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-brand leading-tight" data-id="element-249">
                    $27.990{' '}
                    <span className="text-sm text-gray-500 font-medium" data-id="element-250">
                      ARS
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-251">
                Ideal para quien quiere resultados en 30 días con mapa día a día
              </p>
            </div>
          </motion.button>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6" data-id="element-252">
          <a href={selected === 'acelerador' ? 'https://ultrapack.digital/cart/47718470353070:1' : 'https://ultrapack.digital/cart/47712619593902:1'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(244,63,122,0.4)] text-base" data-id="element-253">
            →{' '}
            {selected === 'acelerador' ? 'QUIERO EL ULTRAPACK + ACELERADOR' : 'QUIERO MI ULTRAPACK'}
          </a>
        </motion.div>
      </div>
    </section>;
}